var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b',[_vm._ssrNode("Please implement vendor-specific BillingAddressForm component in the 'components/MyAccount' directory")])}
var staticRenderFns = []

export { render, staticRenderFns }